import { FieldNode, Signer } from '@modusign/react-signing/types';
import { DeepReadonly } from 'ts-essentials';

import SignerWithRequiredFieldCount from '@app/features/apply-react-signing/components/Modal/SignerWithoutSignatureField';
import { hasRequired } from '@app/features/apply-react-signing/libs/fieldTypeGuards';
import { filterFieldNodes } from '@app/features/apply-react-signing/libs/filterFieldNode';

export function getSignersWithoutSignatureField(
  signers: DeepReadonly<Signer[]>,
  fields: DeepReadonly<FieldNode[]>
) {
  return signers
    .filter((signer) => {
      return !fields.some(
        (field) => field.participantReference.id === signer.id && field.type === 'SIGNATURE'
      );
    })
    .map<SignerWithRequiredFieldCount>((signer) => {
      return {
        ...signer,
        requiredFieldCount: filterFieldNodes(
          fields,
          (f) =>
            f.participantReference.id === signer.id && hasRequired(f.config) && f.config.required
        ).length,
      };
    });
}
